// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_postcss@8.5.15_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Public visual rules live in src/styles/public-tokens.css and page-owned
 * stylesheets. This file intentionally contains no page selectors so the
 * admin area and public application keep independent cascade boundaries.
 */

:root {
    color-scheme: light;
}
`, "",{"version":3,"sources":["webpack://./src/AppTheme.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;IACI,mBAAmB;AACvB","sourcesContent":["/*\n * Public visual rules live in src/styles/public-tokens.css and page-owned\n * stylesheets. This file intentionally contains no page selectors so the\n * admin area and public application keep independent cascade boundaries.\n */\n\n:root {\n    color-scheme: light;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
